import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Footer from './components/Footer';
import Header from './components/Header';
import SiteAccessTracker from './components/SiteAccessTracker';
import { RequireAdmin, RequireAuth } from './context/AuthContext';
import Access from './pages/Access';
import Admin from './pages/Admin';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Portal from './pages/Portal';

const App = () => {
  return (
    <div className="app-shell d-flex flex-column min-vh-100">
      <SiteAccessTracker />
      <Header />
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/acesso" element={<Access />} />
          <Route
            path="/portal"
            element={
              <RequireAuth>
                <Portal />
              </RequireAuth>
            }
          />
          <Route
            path="/envios"
            element={
              <RequireAuth>
                <Navigate to="/portal?tab=events" replace />
              </RequireAuth>
            }
          />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <Admin />
              </RequireAdmin>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;
